<template>
  <v-row class="justify-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon class="mr-2" v-bind="attrs" v-on="on">mdi-frequently-asked-questions</v-icon>
      </template>
      <span>значение концентрации, осредненное за 20 мин</span>
    </v-tooltip>
    <span class="v-label theme--light custom-label">
      разовое
    </span>
    <v-switch class="custom-switch"
              v-model="discrSwitch"
              label="среднесуточное"
              color="success"
              hide-details
              />
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon class="ml-2" v-bind="attrs" v-on="on">mdi-frequently-asked-questions</v-icon>
      </template>
      <span>значение концентрации, осредненное за 24 часа с 00:20 по 24:00</span>
    </v-tooltip>
  </v-row>
</template>

<script>
import {bus} from "@/main";

export default {
  props: {
    discr: Number,
  },
  data: () => ({
    discrSwitch: false
  }),
  watch: {
    discrSwitch() {
      if (this.discrSwitch === false) {
        bus.$emit('discr-switch', {
          discr: 1
        });
      } else {
        bus.$emit('discr-switch', {
          discr: 4
        });
      }
    }
  },
  created() {
    switch (this.discr) {
      case 1:
        this.discrSwitch = false
            break
      case 4:
        this.discrSwitch = true
            break
    }
  }
}
</script>

<style scoped>

.custom-label {
  height: max-content !important;
  padding-top: 4px;
  padding-right: 7px;
}

.custom-switch {
  padding-top: 0;
  margin-top: 0;
}
</style>